const domainRegex = /^(?:http:\/\/|www\.|https:\/\/)([^\/]+)/gm;

export {
  domainRegex,
};
